import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'Openpay-basic-simple-button',
  templateUrl: './basic-simple-button.component.html',
  styleUrls: ['./basic-simple-button.component.scss']
})
export class BasicSimpleButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
